import { render, staticRenderFns } from "./Instalment.vue?vue&type=template&id=695e1831&"
import script from "./Instalment.vue?vue&type=script&lang=js&"
export * from "./Instalment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports